import { SitecoreIds } from 'lib/constants';
import { RuleContext } from '../../rules';
import { WhenCondition } from '../../conditions';
import { RuleConditionData } from '../../serialization';
import { ConditionRule } from 'lib/reviews/types';
import { RulesConstants } from 'lib/constants/rules';

export const MinimumCharacterCountConditionId =
  SitecoreIds.Settings.Rules.Definitions.Elements.RbA_Reviews.MinimumCharacterCount.ItemId;

export class MinimumCharacterCountCondition<T extends RuleContext> extends WhenCondition<T> {
  minimumCharacters: number;
  constructor(condition: RuleConditionData) {
    super();
    this.minimumCharacters = condition.minimumCharacters as number;
  }

  execute(ruleContext: T): boolean {
    const conditions: Array<ConditionRule> =
      (ruleContext.parameters[RulesConstants.Parameters.Conditions] as Array<ConditionRule>) ?? [];
    conditions.push({
      propertyName: 'review.reviewText',
      comparison: 'lgte',
      value: this.minimumCharacters,
    });
    ruleContext.parameters[RulesConstants.Parameters.Conditions] = conditions;
    return ruleContext.parameters[RulesConstants.Parameters.Operator] ==
      RulesConstants.Operators.And
      ? true
      : false;
  }
}
